require('./brokerOrdersAndMovementsMovementsFilter.scss');
const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
// @ commons
const DateFilter = require('components/commons/dateFilter/dateFilter');
const OKModal = require('components/commons/OKModal/OKModal');

class BrokerOrdersAndMovementsMovementsFilter extends React.Component {

    constructor(props) {
        super(props);

        const { immFilter } = props;
        const immDate = immFilter.get('date');

        this.state = {
            dateSelected: immDate.get('selected'),
            dateFrom: immDate.get('from'),
            dateTo: immDate.get('to')
        };

        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleChangeDateMin = this.handleChangeDateMin.bind(this);
        this.handleChangeDateMax = this.handleChangeDateMax.bind(this);
        this.handleChangeDateSelected = this.handleChangeDateSelected.bind(this);
    }

    handleChangeDateMax(dateTo) {
        this.setState({
            dateTo
        });
    }

    handleChangeDateMin(dateFrom) {
        this.setState({
            dateFrom
        });
    }

    handleChangeDateSelected(dateSelected) {
        this.setState({
            dateSelected
        });
    }

    handleFormSubmit(event) {
        event.preventDefault();

        const {setFilter, onCloseClick, valueId} = this.props;
        const {dateFrom, dateTo, dateSelected} = this.state;

        const newFilter = {
            date: {
                selected: dateSelected,
                from: dateFrom,
                to: dateTo,
                isActive: true
            }
        };

        setFilter(newFilter, valueId);
        onCloseClick();
    }

    render() {
        const { immFilter, onCloseClick, isModalOpen } = this.props;

        const modalContent = (
            <div className="broker-orders-and-movements-movements-filter">
                <form className="broker-orders-and-movements-movements-filter__form" onSubmit={this.handleFormSubmit}>
                    <fieldset>
                        <DateFilter
                            immFilter={immFilter.get('date')}
                            onChangeMin={this.handleChangeDateMin}
                            onChangeMax={this.handleChangeDateMax}
                            onChangeSelected={this.handleChangeDateSelected}
                        />
                    </fieldset>
                </form>
            </div>
        );

        return (
            <OKModal
                content={modalContent}
                isOpen={isModalOpen}
                onCloseCallback={onCloseClick}
                title="filters-title"
                footerType="navigation"
                onPrimaryButtonClick={this.handleFormSubmit}
                onSecondaryButtonClick={onCloseClick}
                primaryButtonText="filterDate-apply"
                secondaryButtonText="filterDate-cancel"
            />
        )
    }
}

BrokerOrdersAndMovementsMovementsFilter.propTypes = {
    onCloseClick: PropTypes.func.isRequired,
    immFilter: PropTypes.object.isRequired,
    valueId: PropTypes.string.isRequired,
    setFilter: PropTypes.func.isRequired,
    isModalOpen: PropTypes.bool.isRequired
}

module.exports = BrokerOrdersAndMovementsMovementsFilter;
